export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE'
export const SET_USER_LOGIN_EMAIL = 'USER_LOGIN_EMAIL'
export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST'
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE'
export const SET_USER_REGISTER_EMAIL = 'SET_USER_REGISTER_EMAIL'
export const CHECK_USER_REQUEST = 'CHECK_USER_REQUEST'
export const CHECK_USER_SUCCESS = 'CHECK_USER_SUCCESS'
export const CHECK_USER_FAILURE = 'CHECK_USER_FAILURE'
export const USER_STATUS_REQUEST = 'USER_STATUS_REQUEST'
export const USER_STATUS_SUCCESS = 'USER_STATUS_SUCCESS'
export const USER_STATUS_FAILURE = 'USER_STATUS_FAILURE'
